import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import L from "leaflet";
import dayMarkerIcon from "../assets/marker-day.png";
import nightMarkerIcon from "../assets/marker-night.png";
import agencyMarkerIcon from "../assets/0emwie0m.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import axiosInstance from "../api/axiosConfig";

// Ejemplo de tamaño de ícono un poco más grande:
const iconDay = (size = 45) =>
  L.icon({
    iconUrl: dayMarkerIcon,
    shadowUrl: markerShadow,
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
  });

const iconNight = (size = 45) =>
  L.icon({
    iconUrl: nightMarkerIcon,
    shadowUrl: markerShadow,
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
  });

const iconAgency = (size = 45) =>
  L.icon({
    iconUrl: agencyMarkerIcon,
    shadowUrl: markerShadow,
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
  });

const centerEcuador = [-1.8312, -78.1834];

const VehicleLocationsMapGrouped = ({ dayData = [], nightData = [] }) => {
  const [agencies, setAgencies] = useState([]);

  useEffect(() => {
    const fetchAgencies = async () => {
      try {
        const response = await axiosInstance.get("/agencies");
        setAgencies(response.data);
      } catch (error) {
        console.error("Error al obtener agencias:", error);
      }
    };
    fetchAgencies();
  }, []);

  return (
    <div style={{ width: "100%", height: "600px" }}>
      <MapContainer
        center={centerEcuador}
        zoom={7}
        style={{ width: "100%", height: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; OpenStreetMap contributors"
        />

        {/* Marcadores de Agencias - Siempre visibles */}
        {agencies.map((agency) => {
          const lat = parseFloat(agency.latitude);
          const lng = parseFloat(agency.longitude);
          if (!lat || !lng) return null;
          return (
            <Marker
              key={`agency-${agency.id}`}
              position={[lat, lng]}
              icon={iconAgency(45)}
            >
              <Popup>
                <strong>{agency.name}</strong>
                <br />
                {agency.company}
                <br />
                {agency.address}
              </Popup>
              <Tooltip>
                {agency.name} - {agency.company}
              </Tooltip>
            </Marker>
          );
        })}

        {/* Agrupación solo para marcadores de ubicaciones */}
        <MarkerClusterGroup chunkedLoading>
          {/* Marcadores de Diurno */}
          {dayData.map((item, idx) => {
            const lat = parseFloat(item.avg_lat);
            const lng = parseFloat(item.avg_lng);
            if (!lat || !lng) return null;
            return (
              <Marker
                key={`day-${idx}`}
                position={[lat, lng]}
                icon={iconDay(45)}
              >
                <Popup>
                  <strong>{item.level}</strong> (Diurno)
                  <br />
                  Vehículos: {item.total_vehiculos}
                </Popup>
                <Tooltip>
                  {item.level}: {item.total_vehiculos} (Diurno)
                </Tooltip>
              </Marker>
            );
          })}

          {/* Marcadores de Nocturno */}
          {nightData.map((item, idx) => {
            const lat = parseFloat(item.avg_lat);
            const lng = parseFloat(item.avg_lng);
            if (!lat || !lng) return null;
            return (
              <Marker
                key={`night-${idx}`}
                position={[lat, lng]}
                icon={iconNight(45)}
              >
                <Popup>
                  <strong>{item.level}</strong> (Nocturno)
                  <br />
                  Vehículos: {item.total_vehiculos}
                </Popup>
                <Tooltip>
                  {item.level}: {item.total_vehiculos} (Nocturno)
                </Tooltip>
              </Marker>
            );
          })}
        </MarkerClusterGroup>
      </MapContainer>
    </div>
  );
};

export default VehicleLocationsMapGrouped;
